import React from 'react'
import { Gift } from 'react-bootstrap-icons'
import { GiftMeButton } from './styles'

import { useLanguage, useApi } from '~components'

export const GiftMeLoginButton = () => {
  const [, t] = useLanguage()
  const [ordering] = useApi()

  const projectCode = ordering?.project

  const redirectUrl = encodeURIComponent(`${window.location.origin}/giftme-callback`)
  const giftMeUrl = `https://giftme.plugins.orderingplus.com/${projectCode}/views/authentication?redirect_url=${redirectUrl}`

  const handleOpenPopup = () => {
    const width = 500
    const height = 600
    const left = window.screenX + (window.outerWidth - width) / 2
    const top = window.screenY + (window.outerHeight - height) / 2

    window.open(
      giftMeUrl,
      'GiftMeLogin',
      `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
    )
  }

  return (
    <GiftMeButton
      initialIcon
      color='secondary'
      onClick={handleOpenPopup}
    >
      <Gift />
      <div>{t('LOGIN_WITH_GIFTME', 'Login with GiftMe')}</div>
    </GiftMeButton>
  )
}
